import {
	Building2,
	Calendar,
	CheckSquare,
	DollarSign,
	File,
	FileText,
	KeyRound,
	type LucideIcon,
	Megaphone,
	Smartphone,
	UserCog,
	Users,
	UtensilsCrossed,
} from "lucide-react";
import { AdminModuleKey } from "../features/auth/adminModules";

export interface AppNavItem {
	name: string;
	href: string;
	icon: LucideIcon;
	moduleKey?: string;
}

export const APP_NAV_ITEMS: AppNavItem[] = [
	{
		name: "User Management",
		moduleKey: AdminModuleKey.USER_MANAGEMENT,
		href: "/users",
		icon: Users,
	},
	{
		name: "Properties",
		moduleKey: AdminModuleKey.PROPERTY_MANAGEMENT,
		href: "/properties",
		icon: Building2,
	},
	{
		name: "Event Management",
		moduleKey: AdminModuleKey.EVENT_MANAGEMENT,
		href: "/events",
		icon: Calendar,
	},
	{
		name: "Property Marketing",
		moduleKey: AdminModuleKey.PROPERTY_MARKETING,
		href: "/property-marketing",
		icon: Megaphone,
	},
	{
		name: "F&B Management",
		moduleKey: AdminModuleKey.FNB_MANAGEMENT,
		href: "/restaurant-booking",
		icon: UtensilsCrossed,
	},
	{
		name: "Beneficiary Approvals",
		moduleKey: AdminModuleKey.BENEFICIARY_APPROVALS,
		href: "/approvals",
		icon: CheckSquare,
	},
	{
		name: "Charges Management",
		moduleKey: AdminModuleKey.CHARGES_MANAGEMENT,
		href: "/charges-management",
		icon: File,
	},
	{
		name: "Revenue Management",
		moduleKey: AdminModuleKey.REVENUE_MANAGEMENT,
		href: "/revenue-management",
		icon: DollarSign,
	},
	{
		name: "Monthly Statement",
		moduleKey: AdminModuleKey.MONTHLY_STATEMENT,
		href: "/monthly-statements",
		icon: FileText,
	},
	{
		name: "Roles and Permissions",
		moduleKey: AdminModuleKey.ROLES_AND_PERMISSIONS,
		href: "/roles-permissions",
		icon: KeyRound,
	},
	{
		name: "Kerzner Sub Admin Management",
		moduleKey: AdminModuleKey.KERZNER_SUB_ADMIN,
		href: "/sub-admin",
		icon: UserCog,
	},
	{
		name: "Static Content",
		moduleKey: AdminModuleKey.STATIC_CONTENT,
		href: "/static-content",
		icon: FileText,
	},
	{
		name: "App Update",
		moduleKey: AdminModuleKey.APP_UPDATE,
		href: "/app-update",
		icon: Smartphone,
	},
];
